import { UserCheck, BadgeCheck, Timer, Receipt } from "lucide-react";

const benefits = [
  { icon: UserCheck, title: "Ein Ansprechpartner", description: "Ein zentraler Kontakt – ManageMatch koordiniert Hausmeister, Reinigung, Elektro und alle weiteren Services.", span: "lg:col-span-7", bg: "bg-lavender" },
  { icon: BadgeCheck, title: "Geprüfte Fachkräfte", description: "Qualifizierte Profis mit nachgewiesener Erfahrung in Hanau & Rhein-Main.", span: "lg:col-span-5", bg: "bg-sky" },
  { icon: Timer, title: "24–48h Umsetzung", description: "Wir organisieren den passenden Dienstleister – auch kurzfristig und bei Notfällen.", span: "lg:col-span-5", bg: "bg-butter" },
  { icon: Receipt, title: "Transparente Preise", description: "Kostenlose Beratung und unverbindliche Angebote – ohne versteckte Kosten.", span: "lg:col-span-7", bg: "bg-rose" },
];

const BenefitsSection = () => (
  <section id="why-us" className="py-12 md:py-20 bg-muted">
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-5 max-w-6xl mx-auto">
        <div className="md:col-span-2 lg:col-span-12 glass-card rounded-2xl md:rounded-3xl p-5 md:p-10">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-3">Warum ManageMatch dein Vorteil ist</h2>
          <p className="text-lg text-muted-foreground max-w-2xl">Zuverlässig, schnell und transparent – wir planen, koordinieren und steuern.</p>
        </div>
        {benefits.map((b) => (
          <div key={b.title} className={`${b.span} ${b.bg} rounded-2xl md:rounded-3xl p-4 md:p-7 border border-border/40 flex gap-4 md:gap-5 items-start hover:-translate-y-1 transition-transform`}>
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl md:rounded-2xl bg-card/80 flex items-center justify-center shrink-0">
              <b.icon className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-semibold text-foreground mb-2">{b.title}</h3>
              <p className="text-muted-foreground">{b.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BenefitsSection;
